<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    


<g>
	<path d="M0,141.7h141.7V86.4c-2.7-4.5-4.3-9.8-4.3-15.6c0-5.7,1.6-11.1,4.3-15.6V0H0V141.7z M73.6,46.9L85,44.2v6.7
		c3.7-2.5,8-4,12.7-4c12.8,0,23.1,10.8,23.1,24c0,13.3-10.3,24-23.1,24c-4.7,0-9.1-1.5-12.8-4v16l-11.3,2.6
		C73.6,109.5,73.6,46.9,73.6,46.9z M24.6,32.4l11.8-2.6v41.9c0,5.3,1,11.9,10.2,11.9c8.2,0,9.8-5.6,9.8-12.9V32.4L68,29.8v45.3
		C68,86.2,59.6,95,45.9,95c-10.5,0-21.4-6-21.4-21.6L24.6,32.4L24.6,32.4z"/>
	<path d="M97,84.6c7.6,0,13.1-6.3,13.1-13.7c0-7.4-5.5-13.7-13.1-13.7s-13.1,6.3-13.1,13.7S89.4,84.6,97,84.6z"/>
	<path d="M235.4,79.2c-4.7,3.1-9,5.3-14.8,5.3c-5.4,0-7.9-2.7-8.8-4.5l31-19.2c-4-8.4-12.2-14-21.6-14c-13.4,0-25.1,10.4-25.1,24.1
		c0,13.6,11.8,24.1,25.1,24.1c6.7,0,13.5-2.1,19-6L235.4,79.2z M207.2,69c0.6-6.9,6.3-12.7,13.5-12.7c3,0,5.8,0.8,7.9,2.9L207.3,72
		C207.2,70.9,207.2,70,207.2,69z"/>
	<polygon points="235.5,28 221.7,28 213.3,41 222.2,41 	"/>
	<polygon points="246.3,36.1 254,43.7 261.6,36.1 254,28.5 	"/>
	<path d="M248.1,93.2c0,5.5-4.2,7.9-9.1,7.9c-1.5,0-2.4-0.2-3.3-0.3l3.5,9.9c1.2,0.1,2.6,0.2,4,0.2c10.1,0,16.2-6.1,16.2-15.7v-48
		l-11.3,1.1L248.1,93.2L248.1,93.2z"/>
	<path d="M290.6,46.8c-13.4,0-25.1,10.4-25.1,24.1c0,13.6,11.8,24.1,25.1,24.1c6.7,0,13.5-2.1,19-6l-4.8-9.7
		c-4.7,3.1-9,5.3-14.8,5.3c-5.4,0-7.9-2.7-8.8-4.5l31-19.2C308.2,52.4,300,46.8,290.6,46.8z M276.7,72c-0.2-1.1-0.2-2.1-0.2-3
		c0.6-6.9,6.3-12.7,13.5-12.7c3,0,5.8,0.8,7.9,2.9L276.7,72z"/>
	<path d="M346.8,74c0,5.7-3.3,11.1-10.4,11.1c-5.1,0-7.3-4-7.3-8.8V46.8l-11.3,1.4v31.1c0,9.6,6.2,15.6,15.6,15.6
		c6.3,0,10.1-1.4,13.9-6.6h0.2v5.9l10.7-0.7V46.8l-11.3,1.4V74H346.8z"/>
	<path d="M392.1,46.8c-6.3,0-10.1,1.4-13.9,6.6H378v-6.2l-10.7,1.1l0,0v46l11.3-0.7V67.7c0-5.7,3.3-11.1,10.4-11.1
		c5.1,0,7.3,4,7.3,8.8v28.8l11.3-0.7V62.4C407.7,52.8,401.5,46.8,392.1,46.8z"/>
	<path d="M439.3,46.8c-13.4,0-25.1,10.4-25.1,24.1c0,13.6,11.8,24.1,25.1,24.1c6.7,0,13.5-2.1,19-6l-4.8-9.7
		c-4.7,3.1-9,5.3-14.8,5.3c-5.4,0-7.9-2.7-8.8-4.5l31-19.2C456.8,52.4,448.6,46.8,439.3,46.8z M425.4,72c-0.2-1.1-0.2-2.1-0.2-3
		c0.6-6.9,6.3-12.7,13.5-12.7c3,0,5.8,0.8,7.9,2.9L425.4,72z"/>
	<path d="M476.7,55.4h-0.2v-8.2l-10.7,1.1v46l11.3-0.7V71.7c0-7.8,3.8-12.9,12.5-12.9l3.9-12C485.7,46.9,480.7,48.3,476.7,55.4z"/>
	<path d="M178.3,51.6c-4.2-3.5-8.9-4.8-13.5-4.8c-12.9,0-22.4,11.5-22.4,24.1S151.8,95,164.8,95c6.2,0,9.4-1.6,14.1-6.3v6l10.7-1.1
		V30.9l-11.3,1.4V51.6z M166.2,84.6c-7.6,0-13.1-6.3-13.1-13.7c0-7.4,5.5-13.7,13.1-13.7s13.1,6.3,13.1,13.7
		C179.4,78.3,173.8,84.6,166.2,84.6z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    name: {
      type: String,
      required: false,
      default: 'UpFull',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 493.6 141.7',
    },
  },
};
</script>

<style scoped>
  
</style>